<template>
    <data-hud class="data-hud" :title="t('vital_signs.facialSkinAge.title')" unit="" :data="data"/>
</template>

<script>
import DataHud from "./data-hud.vue"
import { useI18n } from 'vue-i18n';

export default
  {
    name: 'facial-skin-age',
    props: {
        data: Number
    },
    setup() {
    const { t, locale } = useI18n()
    return {t, locale}
    },
    components: { DataHud }
}
</script>

<style scoped>
.data-hud {
    position: relative;
}
@media (max-width: 768px) {
    .data-hud {
        position: relative;
        left: auto;
        top: auto;
    }
}
</style>


